import React from 'react';
import Button from '../Button';
import Empty from '../Empty';
import FontAwesomeIcon from '../Icon';
import Overlay from '../Overlay';
import Table, { Hidden } from './TableIndex';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Loader from '../Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import EmailTemplateForm from '../EmailTemplateForm';
import { fetchEmailTemplates, updateEmailTemplate, setEmailTemplateForm, clearEmailTemplateForm, setEmailTemplates, clearEmailTemplates } from '../../store/actions/emailTemplates';

class EmailTemplatesTable extends React.Component {
  state = {
    showOverlay: false
  };

  componentDidMount(){
    const {user,fetchEmailTemplates}=this.props;
    fetchEmailTemplates(user?.id)
  }
edit(data){
  const {setEmailTemplateForm, user} = this.props;
  this.setState({ showOverlay: true})
  setEmailTemplateForm({...data, userId:user?.id})
}
  render() {
    const { loader } = this.props;
    const {emailTemplates}=this.props.emailTemplates;
    const emailTemplatesData =[...emailTemplates].reverse();
    const { showOverlay } = this.state;    
    return (
      <>
        {loader ? <Loader center={true}/> : null}
        {emailTemplates.length > 0 ? (
          <>
            <Table
              columns={[
                {
                  label: 'Action',
                  accessor: 'name',
                  cell: data => <div title={data.name}>{data.name}</div>
                }, {
                  label: 'Subject',
                  accessor: 'subject',
                  cell: data => <div title={data.subject}>{data.subject}</div>
                },
                {
                  label: 'Role',
                  accessor: 'role',
                  cell: data => data.role ? <div title={data.role}>{data.role}</div>:<div title='N/A'>N/A</div>
                },
                 {
                   xsHide: true,
                  cell: data => (
                    <Hidden>
                      <Button
                        color="semantic"
                        label={(
                          <FontAwesomeIcon
                            glyph="pencil"
                            weight="light"
                          />
                        )}
                        onClick={() => this.edit(data)}
                      />
                    </Hidden>
                  )
                }
              ]}
              data={emailTemplatesData}
            />
          </>
        ) : (
          <Empty
            direction="ttb"
            headline="No Email Templates Yet"
            strapline="Keep all your Email Templates here so it’s easier for you to manage."
            image={(
              <img
                alt="No Email Templates yet"
                src="/assets/empty/contacts.svg"
              />
            )}
          />
        )}
          <Overlay
          showOverlay={showOverlay}
          content={(
            <EmailTemplateForm
              from={'EmailTemplateForm'}
              breadcrumb={'Updating'}
              onSaveNote={()=>alert('Clicked..!!')}
              onClose={() => this.setState({ showOverlay: false })}
            />
          )}
        />
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  loader: selectFormLoader(state),
  user:selectAuthenticatedUser(state),
  emailTemplates:state.emailTemplates,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchEmailTemplates, 
  updateEmailTemplate, 
  setEmailTemplateForm, 
  clearEmailTemplateForm, 
  setEmailTemplates, 
  clearEmailTemplates
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(EmailTemplatesTable);
